import React from 'react';
import ContributorsBarChartCard from '../../../components/contributors/ContributorsBarChartCard';
import { FeatureGate } from '../../../contexts/FeatureFlagContext';

export default function RepositoryContributorsTab({
  repositoryId,
  contributorRows,
  contributorsLoading,
  timeframe,
  status,
  onTimeframeChange,
  onStatusChange,
}: any) {
  return (
    <div role="tabpanel" id="repo-tabpanel-contributors" aria-labelledby="repo-tab-contributors">
      <FeatureGate flag="ui.repositoryDetail.contributorsTab">
        <ContributorsBarChartCard
          contributorRows={contributorRows}
          loading={contributorsLoading}
          listKey={`repo-${repositoryId}`}
          timeframe={timeframe}
          status={status}
          onTimeframeChange={onTimeframeChange}
          onStatusChange={onStatusChange}
        />
      </FeatureGate>
    </div>
  );
}
